<template>
  <el-container>
    <el-header>
      <app-header></app-header>
    </el-header>
    <el-container class="app-wrapper " :class="{'full-screen': fullScreen}">
      <el-aside width="auto" class="me-3 overflow-hidden hidden-sm">
        <app-aside></app-aside>
      </el-aside>
      <el-main class="loading-wrapper">
        <router-view></router-view>
        <section>
            <div class="text-muted text-center p-4 my-5">
                <div>21世纪房车 &copy; Since 2002</div>
            </div>
        </section>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
import AppAside from "./common/aside";
import AppHeader from "./common/header.vue";
export default {
  name: "Home",
  components: {
    AppAside,
    AppHeader,
  },
  data() {
    return {
      fullScreen: false,
    };
  },
  created() {
    // TODO 全屏模式
    const config = JSON.parse(localStorage.getItem('CONFIG_MP_21RV'))
    this.fullScreen = config ? config.fullScreen : false
  }
};
</script>
<style lang="scss" scoped>
</style>
